export const MARKET_ACTION_TYPES = {
  SET_MARKET_VALUES: "market/SET_MARKET_VALUES",
  FETCH_MARKET_VALUES: "market/FETCH_MARKET_VALUES",
  FETCH_MARKET_VALUES_BTC: "market/FETCH_MARKET_VALUES_BTC",
  FETCH_TOP_MARKET_VALUES: "market/FETCH_TOP_MARKET_VALUES",
};
